import { render, staticRenderFns } from "./failed.vue?vue&type=template&id=61cdd09f&scoped=true&"
import script from "./failed.vue?vue&type=script&setup=true&lang=js&"
export * from "./failed.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./failed.vue?vue&type=style&index=0&id=61cdd09f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cdd09f",
  null
  
)

export default component.exports